import { Field, Form, Formik } from "formik";
import Title from "../../components/common/title/Title";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { postApi, putApi } from "../../services/api/globalApi";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import { useEffect, useRef, useState } from "react";
import { categoryValidation } from "../../utils/validations/categoryValidation";
import { useLocation, useNavigate } from "react-router";
import CategoriesSelect from "../../components/common/inputs/CategoriesSelect";
import Select from "../../components/common/inputs/Select";
import { fileUrl } from "../../services/config";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function LearnCategory() {
  const location = useLocation();
  const navigate = useNavigate();

  const { utils } = useSelector(utilsState);

  const formHandler = async (values, { resetForm }) => {
    console.log(values);
    const body = {
      ...values,
      image: image,
    };
    try {
      if (location.state) {
        await putApi({
          path: `admin/learnCategories/${location.state?.id}`,
          body: JSON.stringify(body),
        });
        successMessage("دسته بندی با موفقیت ویرایش شد");
      } else {
        await postApi({
          path: "admin/learnCategories",
          body: JSON.stringify(body),
        });
        successMessage("دسته بندی با موفقیت اضافه شد");
      }
      resetForm();
      navigate("/learn-category-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };


  useEffect(() => {
    if (location?.state?.image) {
      setImage(location.state.image);
    }
  }, [location.state]);

  const imagesModal = useRef();
  const [image, setImage] = useState("");

  const selectedImages = (item) => {
    console.log(item);
    if (item) {
      setImage(item.name);
      successMessage("عکس اضافه شد.");
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"افزودن دسته بندی آموزشات"} />
      <Formik
        enableReinitialize
        initialValues={{
          name: location?.state?.name || "",
          status:
            location?.state?.status ||
            utils?.CATEGORY_STATUS_VALUES[0]?.value ||
            "",
        }}
        validationSchema={categoryValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input name="name" placeholder="نام" label="نام" type="text" />
                {utils ? (
                  <Field
                    as="select"
                    name="status"
                    label="وضعیت"
                    component={Select}
                  >
                    {utils?.CATEGORY_STATUS_VALUES.map((item) => {
                      return <option value={item.value}>{item?.name}</option>;
                    })}
                  </Field>
                ) : null}

                <div className="">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    عکس
                  </label>
                  <div className="flex items-center justify-between">
                    <div className="flex gap-2">
                      {image ? (
                        <img
                          src={`${fileUrl}files/thumb_${image}`}
                          className="w-16 h-16 rounded-lg"
                          alt=""
                        />
                      ) : (
                        <p className="text-sm dark:text-white">هنوز هیچ عکسی اننتخاب نشده</p>
                      )}
                      {/* <p className="max-w-12 overflow-hidden">{image || ""}</p> */}
                    </div>
                    <div className="flex gap-2">
                      {image && (
                        <Button
                          type="button"
                          onClick={() => setImage("")}
                          text={"حذف"}
                          color={"danger"}
                        />
                      )}

                      <Button
                        type="button"
                        onClick={() => imagesModal.current.showModal()}
                        text={image ? "ویرایش" : "انتخاب"}
                        color={"success"}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="mt-6">
                  <Button
                    text={location?.state ? "ویرایش" : "افزون"}
                    type={"success"}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
    </div>
  );
}
